
import SocialHeader from '@/components/SocialHeader';
import Nav from '@/components/Nav/Nav';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faClock, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import  './Header.scss';

export default function Header() {
    return (
      <>
        <header className="l-header">
        <div className="l-header__inner">
  

            <div className="l-header__logo">
                <a href="/" rel="home" title="{{ .Site.Title }} Home" className="active">
                <img
                src="/media/logo.svg"
                alt="Logo"
                />
                </a>
            </div>

            <div className="l-header__right">
                <div className="l-header__contact-details">
                <SocialHeader />
              
                    <div className="block-compare-vehicles compare-count">
                    <a href="/compare/" id="saved-vehicles" className="ga_push_browser_listener-processed" rel="nofollow">
                        <FontAwesomeIcon icon={faStar} className="fa-fw" /> (<span id="compare-count">3</span>) Compare Vehicles
                    </a>
                    </div>          
   

                <div className="l-header__contact-details--right">
                    <div className="header-hours"><a data-bs-toggle="modal" data-bs-target="#headerHours"><span><FontAwesomeIcon icon={faClock} className="fa-fw" /> Opening Hours</span></a></div>
 
                    <div className="modal fade" id="headerHours">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <h2>Opening Hours</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <a className="header-phone"  data-bs-toggle="modal" data-bs-target="#mobilePhoneNos"><span><FontAwesomeIcon icon={faPhoneAlt} className="fa-fw" /> Get in Touch</span></a>

                    <div className="modal fade" id="mobilePhoneNos">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <h2>Get in touch, we will be happy to help you</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                </div>

                <div className="l-header__nav">
                <Nav />
                </div>
            </div>
            </div>
    
        </header>
      </>
    );
  }
  